<ion-item lines="none" class="ion-no-padding">
  <gc-tooltip *ngIf="pendingChangeOrders" slot="end" size="medium" style="cursor: pointer; margin-top: 3px">
    Total may change once Open Changes are accepted.
  </gc-tooltip>
  <strong data-cy="work-order-item-total" slot="end" style="margin-inline-start: 12px">
    Total: {{ total || (total$ | push) | currency }}
  </strong>
</ion-item>
